import SubSectionHeader from "../../elements/SubSectionHeader";
import DugoutCardInfoSection from "./DugoutCardInfoSection";
import DugoutLogosSection from "./DugoutLogosSection";

const DugoutCardSection = () => {
  return (
    <div className="d-flex">
      <div style={{ width: "100%" }}>
        <SubSectionHeader title="Card Info" />
        <DugoutCardInfoSection />
      </div>
      <div style={{ width: "24px" }} />
      <div style={{ width: "100%" }}>
        <SubSectionHeader title="Logos" />
        <DugoutLogosSection />
      </div>
    </div>
  );
};

export default DugoutCardSection;
